import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { Back, Button } from 'react-wot-bootstrap'

import { BACK_CAPTIONS } from 'components/Back/constants'

import { KEY_CODES } from 'constants'

import styles from './WGCWXRewardsTankConfirmation.scss'

class WGCWXRewardsTankConfirmation extends React.Component {
    static propTypes = {
        buttonsOptions: PropTypes.arrayOf(PropTypes.shape({
            caption: PropTypes.element.isRequired,
            callback: PropTypes.func.isRequired,
        })).isRequired,
        description: PropTypes.node,
        title: PropTypes.element.isRequired,
        messageType: PropTypes.oneOf(['error', 'alert']),

        children: PropTypes.element,

        onClose: PropTypes.func.isRequired,
    }

    componentDidMount() {
        window.addEventListener('keydown', this.handleKeyPress)
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyPress)
    }

    handleKeyPress = e => {
        if (e.keyCode !== KEY_CODES.ESCAPE) return

        this.props.onClose()
    }

    render() {
        const imageClassNames = classNames(
            styles.image,
            this.props.messageType && styles[`image__${this.props.messageType}`]
        )
        return (
            <div className={styles.base}>
                <div className={styles.back}>
                    <Back
                        side="right"
                        type="close"
                        caption={BACK_CAPTIONS.close}
                        onClick={this.props.onClose}
                    />
                </div>
                <div className={styles.content}>
                    <div className={imageClassNames} />
                    <h1 className={styles.header}>{this.props.title}</h1>
                    {
                        this.props.description &&
                        <p className={styles.description}>
                            {this.props.description}
                        </p>
                    }
                    <div className={styles.separator}>
                        <span className={styles.separator_image} />
                    </div>
                    {this.props.children}
                    <div className={styles.buttons}>
                        {
                            this.props.buttonsOptions.map((button, index) => (
                                <Button
                                    key={index === 0 ? 'default' : 'secondary'}
                                    type={index === 0 ? 'default' : 'secondary'}
                                    onClick={button.callback}
                                    mixClassName={styles.button}
                                >
                                    {button.caption}
                                </Button>
                            ))
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default WGCWXRewardsTankConfirmation



// WEBPACK FOOTER //
// ./containers/WGCWXShop/containers/WGCWXRewardsTank/components/WGCWXRewardsTankConfirmation/WGCWXRewardsTankConfirmation.jsx